import { memo } from 'react';
import { compose } from 'redux';
import { withFormik } from 'formik';
// utilities
import * as U from '../utilities';
// forms
import { Fieldset, FormFooter } from '../components/forms';
// components
import {
  reportFields,
  submitBtnStyles,
  validationSchema,
  defaultReportFields,
} from '../components/report-format-panel/settings/fields-settings';
//////////////////////////////////////////////////

const enhance = compose(
  withFormik({
    validationSchema,
    handleSubmit: (values, { props }) => {
      const {submitAction } = props;

      submitAction(values);
    },
    mapPropsToValues: ({ initialValues }) => U.setInitialFormikValues(
      defaultReportFields,
      initialValues,
    ),
  }),
  memo,
);

const ReportForm = enhance(props => {
  const { handleSubmit } = props;

  return (
    <form onSubmit={handleSubmit}>
      <Fieldset
        {...U.getFormikProps(props)}
        fields={reportFields}
      />
      <FormFooter submitBtnStyles={submitBtnStyles} {...props} />
    </form>
  );
});

export default ReportForm;
